import { render, staticRenderFns } from "./StudentCertificate.vue?vue&type=template&id=57ec32c0"
import script from "./StudentCertificate.vue?vue&type=script&lang=js"
export * from "./StudentCertificate.vue?vue&type=script&lang=js"
import style0 from "./StudentCertificate.vue?vue&type=style&index=0&id=57ec32c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports